import {
  darken,
  lighten,
} from './utils';

export const baseColors = {
  white: '#ffffff',
  black0: '#000000',
  black1: '#1F1F1F',
  black2: '#424242',
  black3: '#888888',
  black4: '#CCCCCC',
  black5: '#F2F2F2',

};


export function makeScale(c, n) {
  const scale = [];

  const maxDarken = 0.5;
  const maxLighten = 0.7;

  const nDarken = 2;
  const nLighten = n - 1 - nDarken;
  const stepDarken = maxDarken / nDarken;
  const stepLighten = maxLighten / nLighten;

  for (let i = nDarken; i > 0; i--) {
    scale.push(darken(c, stepDarken * i));
  }
  scale.push(c);
  for (let i = 1; i <= nLighten; i++) {
    scale.push(lighten(c, stepLighten * i));
  }

  scale.reverse();

  return scale;
}


const def = {
  // colors that might be needed in components
  white: baseColors.white,
  black0: baseColors.black0,
  black1: baseColors.black1,
  black2: baseColors.black2,
  black3: baseColors.black3,
  black4: baseColors.black4,
  black5: baseColors.black5,

  // new
  primary: '#A54DE2',
  secondary: '#FF964A',
  tertiary: '#62C3C6',
  helper: '#7B8FF7',
  background: '#fff',
};

let colors = { ...def };

function makeExtraColors() {
  colors.bg = colors.background;
  colors.highlight = colors.secondary;

  ['primary', 'secondary', 'tertiary', 'helper', 'highlight'].forEach((c) => {
    colors[`${c}D`] = darken(colors[c], 0.4);
    colors[`${c}L`] = lighten(colors[c], 0.4);
  });

  colors.mapColor1 = colors.primary;
  colors.mapColor1D = colors.primaryD;
  colors.mapScale1 = makeScale(colors.primary, 6);

  colors.mapColor2 = colors.secondary;
  colors.mapColor2D = colors.secondaryD;
  colors.mapScale2 = makeScale(colors.secondary, 6);

  colors.mapColor3 = colors.tertiary;
  colors.mapColor3D = colors.tertiaryD;
  colors.mapScale3 = makeScale(colors.tertiary, 6);

  colors.mapColor4 = colors.helper;
  colors.mapColor4D = colors.helperD;
  colors.mapScale4 = makeScale(colors.helper, 6);
}


makeExtraColors();


export function getColors() {
  return colors;
}


export function setColors(cs) {
  colors = { ...def };
  Object.keys(cs).forEach((k) => {
    if (cs[k]) colors[k] = cs[k];
  });
  makeExtraColors();
}

export function hexToRGB(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return `rgb(${r}, ${g}, ${b})`;
}
